package com.example.positionahead.domain

import com.example.positionahead.model.PortfolioPriceHistory
import com.example.positionahead.model.Position
import com.example.positionahead.model.PricePoint
import com.example.positionahead.model.SymbolPriceHistory
import com.example.positionahead.model.totalShares

object PortfolioHistoryCalculator {

    fun buildPortfolioHistory(
        positions: List<Position>,
        historyBySymbol: Map<String, SymbolPriceHistory>,
    ): PortfolioPriceHistory {
        if (positions.isEmpty() || historyBySymbol.isEmpty()) {
            return PortfolioPriceHistory(emptyList(), null)
        }

        val dates = historyBySymbol.values
            .flatMap { it.points.map { point -> point.date } }
            .distinct()
            .sorted()

        val points = dates.mapNotNull { date ->
            var total = 0.0
            var hasData = false
            positions.forEach { position ->
                val symbol = position.symbol.uppercase()
                val history = historyBySymbol[symbol] ?: return@forEach
                val close = history.points.find { it.date == date }?.close
                    ?: history.points.lastOrNull { it.date <= date }?.close
                if (close != null && close > 0) {
                    total += position.totalShares() * close
                    hasData = true
                }
            }
            if (hasData) PricePoint(date, total) else null
        }

        val changePercent = if (points.size >= 2) {
            val first = points.first().close
            val last = points.last().close
            if (first > 0) ((last - first) / first) * 100 else null
        } else null

        return PortfolioPriceHistory(points, changePercent)
    }
}
